// src/components/FeatureScroll.tsx
import React, { memo } from "react"; 
import { features } from '../data/featureData';
import SingleFeatureDisplay from './SingleFeatureDisplay';

interface FeatureScrollProps {
  scrollY: number;
  activeSection: number;
  viewportHeight: number; // <<< ENSURE THIS IS HERE
  sectionStartVhValues: number[]; // <<< ENSURE THIS IS HERE
  isVisible: boolean;
  isInteractionReady: boolean;
}

// The calculateSectionStartVh function should NOT be here.
// The useState for viewportHeight and useEffect for resize should NOT be here.

const FeatureScroll: React.FC<FeatureScrollProps> = ({
  scrollY,
  activeSection,
  viewportHeight, // This now comes directly from props
  sectionStartVhValues,
  isVisible, // This now comes directly from props
  isInteractionReady,
}) => {

  const containerStyle: React.CSSProperties = {
    opacity: isVisible ? 1 : 0,
    pointerEvents: isVisible ? 'auto' : 'none',
    transition: 'opacity 0.4s ease-in-out',
};

  // The rest of your component logic that maps over features
  // and renders SingleFeatureDisplay components...
  // This part should be the same as the artifact feature_scroll_receives_props

  return (
    <div className="feature-scroll-list-container" style={containerStyle}>
      {features.map((featureItem, arrayIndex) => {
        // Don't render on mobile until transition complete
        const sectionIndexOfFeature = 12 + arrayIndex;

        const proximity = Math.abs(activeSection - sectionIndexOfFeature);
        // if (proximity > 1 && features.length > 3) { // Optional optimization
        //   return null; 
        // }

        return (
          <SingleFeatureDisplay
            key={featureItem.id}
            feature={featureItem}
            sectionIndex={sectionIndexOfFeature}
            isActiveSection={activeSection === sectionIndexOfFeature}
            scrollY={scrollY}
            viewportHeight={viewportHeight} // Pass down
            sectionStartVhValues={sectionStartVhValues} // Pass down
            isInteractionReady={isInteractionReady}
          />
        );
      })}
    </div>
  );
};

export default memo (FeatureScroll);
